import { render } from "./ChartjsDoughnut.vue?vue&type=template&id=52b17d36"
import script from "./ChartjsDoughnut.vue?vue&type=script&lang=js"
export * from "./ChartjsDoughnut.vue?vue&type=script&lang=js"
script.render = render

export default script